












































import VatsAPI from '@/Shared/VatsAPI';
import Vue from 'vue';
import { getValidationErrors } from '@/Shared/ValidationErrorDirective';

class HandheldMessage {
    public recId: number = 0;
    public messageText: string = '';
    public expirationDate: Date | null = null;
}

export default Vue.extend({
    props: ['location'],
    data() {
        return {
            loading: false,
            message: new HandheldMessage(),
            validationErrors: {} as { [key: string]: string[] },
        };
    },
    computed: {
        isMessageValid() {
            if (this.message.messageText === '') {
                return null;
            }
            else if (this.message.messageText.length <= 100) {
                return true;
            }
            return false;
        }
    },
    methods: {
        async saveMessage() {
            this.loading = true;
            try {
                await VatsAPI.post(`${this.location}/HandheldAdmin/HandheldMessage`, this.message);
                this.message = new HandheldMessage();
                this.validationErrors = {};
            }
            catch (e) {
                this.validationErrors = getValidationErrors(e.response);
                throw e;
            }
            finally {
                this.loading = false;
            }
        }
    }
});
